<template>
  <div class="video">
    <h3 v-if="video.title">{{ video.title }}</h3>
    <iframe @load="load" :src="video.url" frameborder="0"></iframe>
    <iframe v-if="!video.url && !isLoading" src frameborder="0">{{ $t("ONLINE_TRAINING.MESSAGE.LOADING_CONTENT") }}</iframe>
    <b-loading :is-full-page="isLoading" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isLoading : true
    }
  },
  computed: {
    ...mapGetters(["video"])
  },
  methods : {
    load() {
      this.isLoading = false
    }
  }
};
</script>

<style lang="scss" scoped>
.video {
  padding: 20px;
  background: white;
  h3 {
    margin-bottom: 20px;
    color: #1a1a1a;
    font-weight: 500;
  }
  iframe {
    width: 100%;
    height: 100px;
    border-radius: 8px;
  }

  h1 {
    font-weight: 500;
    margin-bottom: 20px;
  }
}
@media only screen and (min-width: 1024px) {
  .course {
    .video {
      iframe {
        height: calc(100% - 80px);
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .course {
    .video {
      iframe {
        height: 250px;
      }
    }
  }
}
</style>
